import { BreadCrumbJsonLdProps } from "next-seo";
import { SEO } from "@/constants/seo";
import { BreadcrumbTrail, BreadcrumbSegment } from "@/types/breadcrumbs";

const BASE_PATH = "/";

export const generateBreadcrumbs = (
  breadcrumbSegments: BreadcrumbSegment[]
): {
  trail: BreadcrumbTrail;
  itemListElements: BreadCrumbJsonLdProps["itemListElements"];
} => {
  const trail: BreadcrumbTrail = [
    {
      name: SEO.SITE_NAME,
      url: BASE_PATH,
      position: 1,
    },
  ];

  breadcrumbSegments.forEach((item, position) => {
    trail.push({
      name: item.name,
      url: item.path || undefined,
      position: position + 2,
    });
  });

  const itemListElements = trail.map((item, index) => ({
    position: item.position,
    name: item.name,
    item:
      index === 0
        ? SEO.FANDUEL_URL_RESEARCH // No trailing / for the root path
        : `${SEO.FANDUEL_URL_RESEARCH}${item.url}`,
  }));

  return { trail: trail ?? [], itemListElements };
};
